import BaseWidget from 'components/BaseWidget/BaseWidget';
import CurrentConditionsWidget from './widgets/CurrentConditionsWidget/CurrentConditionsWidget.jsx';
import DopplerRadarWidget from './widgets/DopplerRadarWidget/DopplerRadarWidget.jsx';
import EarthquakesWidget from './widgets/EarthquakesWidget/EarthquakesWidget.jsx';
import HurricanesWidget from './widgets/HurricanesWidget/HurricanesWidget.jsx';
import SevereWeatherAlertsWidget from './widgets/SevereWeatherAlertsWidget/SevereWeatherAlertsWidget.jsx';

const WeatherMapsWidget = ({
  widgetType = 'dopplerRadar',
  dimensions,
  isLoading,
  containerSizePx,
}) => (
  <BaseWidget
    widgetType={widgetType}
    dimensions={dimensions}
    isLoading={isLoading}
    renderers={{
      dopplerRadar: ({ layout }) => <DopplerRadarWidget layout={layout} />,
      earthquakes: ({ layout, dimensions: widgetDimensions }) => (
        <EarthquakesWidget
          layout={layout}
          dimensions={widgetDimensions}
          containerSizePx={containerSizePx}
        />
      ),
      hurricanesTropicalStorms: ({ layout, dimensions: widgetDimensions }) => (
        <HurricanesWidget
          layout={layout}
          dimensions={widgetDimensions}
          containerSizePx={containerSizePx}
        />
      ),
      severeWeatherAlerts: ({ layout, dimensions: widgetDimensions }) => (
        <SevereWeatherAlertsWidget
          layout={layout}
          dimensions={widgetDimensions}
          containerSizePx={containerSizePx}
        />
      ),
      currentConditions: ({ layout, dimensions: widgetDimensions }) => (
        <CurrentConditionsWidget
          layout={layout}
          dimensions={widgetDimensions}
          containerSizePx={containerSizePx}
        />
      ),
    }}
  />
);

export default WeatherMapsWidget;
